var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup78(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 409,
    height: 23,
    viewBox: "0 0 409 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#26093a;font-size:16px;}.a{font-family:Roboto-Regular, Roboto;}.b,.e{fill:none;}.b{stroke:#26093a;stroke-width:2px;}.c{font-family:Roboto-Bold, Roboto;font-weight:700;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-500 -4425)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(532 4443)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021 TradeExpress Technologies All Rights Reserved")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(496 4427)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 10.5,
    cy: 10,
    rx: 10.5,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 10.5,
    cy: 10,
    rx: 9.5,
    ry: 9
  })), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(502 4441)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "c"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup78);
export default __webpack_public_path__ + "static/media/Group 78.7845cc9fc322cc6ea114b53846e855ea.svg";
export { ForwardRef as ReactComponent };